import { useIsMobile, useL10n } from '@uplift/hooks';
import React from 'react';
import { MaskedInput, StatesAutocomplete, TextInput } from '../../Inputs';
import { OptionalBehindButton } from '../../OptionalBehindButton';
import { makeStyles } from 'tss-react/mui';
import { AddressType } from '@uplift/types';

export type AddressFormProps = {
  address2Open: boolean;
  fieldNames: Omit<AddressType, 'address2'> & { address2: string };
};

export const AddressForm: React.VFC<AddressFormProps> = ({ address2Open, fieldNames }) => {
  const isSmall = useIsMobile('sm');
  const l10n = useL10n();
  const { classes, cx } = useStyles();
  const secretFormControl = cx(classes.formControl, 'fs-exclude');
  const buttontext = isSmall
    ? l10n.matching.insurance.addStreetAddress2SmallBreakpoint
    : l10n.matching.insurance.addStreetAddress2;

  return (
    <>
      <TextInput
        fullWidth
        id="address1"
        name={fieldNames.address1}
        label={l10n.matching.insurance.streetAddress}
        className={secretFormControl}
        color="secondary"
      />
      <OptionalBehindButton
        className={classes.marginBottom}
        buttonText={buttontext}
        initialOpen={address2Open}
      >
        <TextInput
          fullWidth
          id="address2"
          name={fieldNames.address2}
          label={l10n.matching.insurance.streetAddress2}
          className={secretFormControl}
          color="secondary"
        />
      </OptionalBehindButton>
      <TextInput
        fullWidth
        id="city"
        name={fieldNames.city}
        label={l10n.editGeneralInfo.city}
        className={secretFormControl}
        color="secondary"
      />
      <StatesAutocomplete
        fullWidth
        id="state"
        name={fieldNames.state}
        label={l10n.editGeneralInfo.state}
        className={cx(classes.state, 'fs-exclude')}
      />
      <MaskedInput
        fullWidth
        id="zip"
        name={fieldNames.zip}
        label={l10n.editGeneralInfo.zipCode}
        className={cx(classes.zip, 'fs-exclude')}
        color="secondary"
        type="zip"
      />
    </>
  );
};

const useStyles = makeStyles({ name: 'AddressFormComponent' })(theme => ({
  addButton: {
    marginTop: -theme.spacing(3) + 10,
    marginBottom: 10,
    '& > button': {
      textAlign: 'left',
      paddingTop: '12px',
      paddingBottom: '12px',
    }
  },
  formControl: {
    marginBottom: theme.spacing(3),
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      width: '75%',
      minWidth: '400px'
    }
  },
  marginBottom: {
    marginBottom: theme.spacing(3),
  },
  state: {
    marginBottom: theme.spacing(3),
    width: '248px',
  },
  zip: {
    marginBottom: theme.spacing(3),
    width: '95px',
  },
}));
